import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EB5A0A",
      d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.771 11.833a2.83 2.83 0 0 1 4.01 0l1.13 1.13c.95.95.89 2.44-.08 3.41l-.71.71c.52 1.14 1.29 2.27 2.31 3.29s2.15 1.79 3.29 2.31l.79-.79c.92-.92 2.41-.92 3.32 0l1.13 1.13a2.83 2.83 0 0 1 0 4.01l-.63.63c-.94.94-2.28 1.31-3.58 1.07-2.73-.52-5.65-2.08-8.13-4.56-2.46-2.48-4.03-5.4-4.55-8.13-.24-1.3.13-2.64 1.07-3.58z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }